"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationOut = void 0;
class IntegrationOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return IntegrationOut.attributeTypeMap;
    }
}
exports.IntegrationOut = IntegrationOut;
IntegrationOut.discriminator = undefined;
IntegrationOut.attributeTypeMap = [
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "updatedAt",
        "baseName": "updatedAt",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=IntegrationOut.js.map